import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const GroupSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default GroupSVG;
